<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

      <h1>Relatório de Acessos</h1>
      <p>Tela com histórico dos últimos {{ logsLocal.length }} acessos ao simulador.</p>
      <div class="callout col-xl-12 col-lg-12 col-md-12 mb-4">
                    <div class="card" style="border-left-color: green;">
                        <div class="card-header" data-toggle="collapse" href="#collapse2" style="color: green;">
                            <strong>Histórico dos últimos acessos</strong>
                        </div>
                        <div id="collapse2" class="collapse show">
                            <div class="card-body">
                                    <p>Este histórico de acesso demonstra a utilização deste simulador em ordem cronológica da mais recente a mais antiga. Se precisar de mais detalhes, utilize os filtros a seguir.<br />
                                        <span style="font-size: small;">* Os registros de acesso que exibem a coluna "Usuário acesso" sem um nome válido referem-se a acessos de usuários que não estão cadastrados no sistema e, portanto, não possuem acesso à área logada deste simulador.</span>
                                    </p>
                                    

                                    <div class="row">
                                        <div class="form-group d-flex align-items-center">
                                        <label for="label" class="input-label mr-2">Buscar por:</label>
                                        <select v-model="tipoPesquisa" class="form-control mr-2" @change="atualizarPlaceholder" style="width: 200px;">
                                            <option value="usuario">Usuário</option>
                                            <option value="link">Link acessado</option>
                                        </select>

                                        <input type="text" class="form-control" :placeholder="placeholderTexto" v-model="textoPesquisa" required style="flex: 1;" />
                                        </div>

                                    <div style="text-align: right; width: 100%;" class="mb-2 mt-1">
                                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="buscar">
                                            <span class="material-icons" style="vertical-align: middle; color: #007BFF;">search</span> 
                                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Buscar</label>
                                        </button>
                                        </div>
                                    </div>
                                    


                                    <table class="table table-striped table-bordered mt-2 border">
                                        <thead>
                                            <tr class="text-center">
                                                <th scope="col" style="background-color: lightgrey;">Código</th>
                                                <th scope="col" style="background-color: lightgrey;">Usuário acesso</th>
                                                <th scope="col" style="background-color: lightgrey;">Link acessado</th>
                                                <th scope="col" style="background-color: lightgrey;">Hora acesso</th>
                                                <th scope="col" style="background-color: lightgrey;">Origem do acesso</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="dado in logsLocal">
                                                <td style="text-align: right;">{{ dado.id }}</td>
                                                <td style="text-align: left;">{{ dado.usuario }}</td>
                                                <td style="text-align: left;">{{ (BASE_URL + dado.rota_acessada).replace("00//", "00/").replace("br//", "br/") }}</td>
                                                <td style="text-align: center;">{{ formatarData(dado.data_acesso) }}</td>
                                                <td style="text-align: center;">{{ dado.ip_acesso }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>{{ logsLocal.length }} registro(s) encontrado(s).</p>
                            </div>
                        </div>
                    </div>
                </div>
      
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            logsLocal: [...this.logs],

            tipoPesquisa: 'usuario',
            textoPesquisa: '',
            placeholderTexto: 'Pesquisa por Usuário',

        };
  },
  
  props: {
        user: {
            type: Object,
            required: true,
        },
        logs: {
            type: Object,
        },
    },
    methods: {
        formatarData(data) {
            const dataFormatada = new Date(data);
            return dataFormatada.toLocaleDateString('pt-BR', {
                day: '2-digit', 
                month: '2-digit', 
                year: 'numeric', 
                hour: '2-digit', 
                minute: '2-digit', 
                second: '2-digit'
            }).replace(',', '');
        },

        atualizarPlaceholder() {
            if (this.tipoPesquisa === 'usuario') {
                this.placeholderTexto = 'Pesquisa por Usuário';
            } else if (this.tipoPesquisa === 'link') {
                this.placeholderTexto = 'Pesquisa por link acessado';
            }
        },
        buscar() {
            if (this.textoPesquisa.trim() === '') {
                alert('Por favor, preencha o campo de pesquisa.');
                return;
            }

            // Parâmetros para a URL
            const params = {
                tipo: this.tipoPesquisa,
                query: this.textoPesquisa
            };

            // Enviar a solicitação GET para o backend usando axios
            axios.get(this.BASE_URL + 'relatorio_acessos_buscar', { params })
                .then(response => {
                    // Processa os dados conforme necessário
                    this.logsLocal = response.data;
                })
                .catch(error => {
                // Lógica para lidar com erros
                console.error('Erro na busca:', error);
                });
        }

    },
    mounted() {
        
    },
    
  };
</script>

<style scoped>
h1{
    font-size: 26px;
}
</style>
  
